import { QueryCache, QueryClient } from '@tanstack/react-query';

import { API_QUERY_DEFAULTS } from '@/hooks/api/defaults';

import { notifyGlobalQueryError } from './queryErrorHandling';

type CreateAppQueryClientOptions = {
  /** When false, query errors are not toasted (unit tests). */
  globalQueryErrorToasts?: boolean;
  queryDefaults?: Omit<typeof API_QUERY_DEFAULTS, 'retry'> & {
    retry?: number | false;
  };
  mutationDefaults?: { retry?: number | false };
};

export function createAppQueryClient(
  options: CreateAppQueryClientOptions = {},
): QueryClient {
  const {
    globalQueryErrorToasts = true,
    queryDefaults = API_QUERY_DEFAULTS,
    mutationDefaults,
  } = options;

  return new QueryClient({
    defaultOptions: {
      queries: queryDefaults,
      mutations: mutationDefaults,
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (!globalQueryErrorToasts || query.meta?.silentError) {
          return;
        }
        notifyGlobalQueryError(error);
      },
    }),
  });
}
